// Copyright (c) StrangeBee 2023

import AssigneeInfo from '@Molecules/AssigneeInfo/AssigneeInfo';
import { ExtractProps } from '@Molecules/Details/Details';
import { FormatDate } from '@Molecules/Format';
import React, { ReactElement } from 'react';
import { Space } from 'antd';
import { cutString } from '@Helpers/string';
import { Link } from 'react-router-dom';

interface ExtractDataProps {
    locale: (...args: any[]) => any;
}

export const extractData = ({ locale }: ExtractDataProps): Record<string, ExtractProps> => ({
    '#computeTitle': {
        name: '',
        render: ({ title, icon, path }: { title: string; icon: ReactElement; path: string }): ReactElement => (
            <div className="result-card__title">
                <Space>
                    {icon}
                    <Link to={path}>{title}</Link>
                </Space>
            </div>
        ),
    },
    '#computeDate': {
        name: '',
        render: ({ date, _createdBy }: { date: number; _createdBy: string }): ReactElement => (
            <div className="result-card__date">
                <FormatDate icon date={date} />
                {_createdBy && <AssigneeInfo assignee={_createdBy} />}
            </div>
        ),
    },
    '#computeDescription': {
        name: '',
        isForce: false,
        render: (description: string): ReactElement => (
            <div className="result-card__description">
                {description === 'N/A' ? locale('common.noDescription') : cutString(description, 140)}
            </div>
        ),
    },
    '#computeCaseTitle': {
        name: '',
        render: ({ title, icon, path }: { title: string; icon: ReactElement; path: string }): ReactElement => (
            <div className="result-card__title">
                <Space align="start">
                    {icon}
                    <Link to={path}>{title}</Link>
                </Space>
            </div>
        ),
    },
});
